import { Breadcrumbs, Typography } from "@mui/material";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import menuNames from "menu/menuNames";

const LinkRouter = ({ to, name }) => (
  <Typography
    component={Link}
    to={to}
    color="textSecondary"
    variant="h6"
    sx={{
      textDecoration: "none",
      "&:hover": {
        textDecoration: "underline",
      },
    }}
  >
    {name}
  </Typography>
);
function Navigation() {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);
  return (
    <>
      <Breadcrumbs aria-label="breadcrumb" separator="›">
        {pathnames.length > 0 && <LinkRouter to="/" name="Home" />}
        {pathnames.map((value, index) => {
          const last = index === pathnames.length - 1;
          const to = `/${pathnames.slice(0, index + 1).join("/")}`;
          return last ? (
            <Typography variant="h6" key={index}>
              {menuNames[value] ?? value}
            </Typography>
          ) : (
            <LinkRouter
              key={index}
              to={to}
              color="textSecondary"
              name={menuNames[value] ?? value}
            />
          );
        })}
      </Breadcrumbs>
    </>
  );
}

export default Navigation;
